<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :close-on-select="false"
      :searchable="true"
      :options="options"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit('onChange', this.value);
    }
  },
  mounted() {
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.loading = true;
      this.$api
        .get('api/sub_affiliate')
        .then((res) => {
          this.loading = false;
          this.options = res.data.map((b) => {
            return { value: b.id, label: b.name };
          });
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
